export default __webpack_public_path__ + "static/media/On_The_Move.21a6ed35.mp3";